import { iIconProps } from '../icon';

export default function Replay({ size, className }: iIconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox='0 0 14 14'
            className={className}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.77413 3.00999H4.43329C4.74829 3.00999 5.00496 3.26666 5.00496 3.58166C5.00496 3.89666 4.74829 4.15333 4.43329 4.15333H2.43829C2.12329 4.15333 1.86663 3.89666 1.86663 3.58166V1.58666C1.86663 1.27166 2.12329 1.01499 2.43829 1.01499C2.75329 1.01499 3.00996 1.27166 3.00996 1.58666V2.16416C3.92694 1.40664 5.04052 0.925633 6.22065 0.777321C7.40078 0.629009 8.59875 0.81951 9.67466 1.32658C10.7506 1.83364 11.66 2.63635 12.2968 3.64095C12.9336 4.64555 13.2714 5.81058 13.2708 6.99999C13.2708 10.465 10.465 13.2708 6.99996 13.2708C3.53496 13.2708 0.729126 10.465 0.729126 6.99999C0.729126 6.68499 0.985793 6.42833 1.30079 6.42833C1.61579 6.42833 1.87246 6.68499 1.87246 6.99999C1.87246 8.36144 2.41329 9.66712 3.37598 10.6298C4.33866 11.5925 5.64435 12.1333 7.00579 12.1333C8.36724 12.1333 9.67292 11.5925 10.6356 10.6298C11.5983 9.66712 12.1391 8.36144 12.1391 6.99999C12.1391 4.16499 9.83496 1.86666 6.99996 1.86666C5.78079 1.86666 4.65496 2.29249 3.77413 3.00416V3.00999Z'
                fill='currentColor'
            />
            <path
                d='M9.30419 7.20999C9.19919 7.57749 8.71503 7.83416 7.74086 8.35333C6.80169 8.85499 6.32919 9.09999 5.95003 9.00083C5.79253 8.95999 5.65253 8.87833 5.53586 8.77333C5.25586 8.51083 5.25586 8.00333 5.25586 6.98249C5.25586 5.96166 5.25586 5.45416 5.53586 5.19166C5.65253 5.08083 5.79253 5.00499 5.95003 4.96416C6.32919 4.86499 6.80169 5.11583 7.74086 5.61166C8.71503 6.13083 9.20503 6.38749 9.30419 6.75499C9.34503 6.90666 9.34503 7.06416 9.30419 7.21583V7.20999Z'
                fill='currentColor'
            />
        </svg>
    );
}
